<template>
  <div class="profile-page">
    <h1 class="page-title">PROFILO</h1>

    <!-- User Info Form -->
    <el-card class="form-card" shadow="never">
      <template #header>
        <span class="card-title">Informazioni Personali</span>
      </template>

      <el-form :model="user_partner" label-position="top">
        <el-row :gutter="24">
          <el-col :sm="8" :xs="24">
            <el-form-item label="Nome">
              <el-input v-model="user_partner.name" placeholder="Inserisci nome" />
            </el-form-item>
          </el-col>

          <el-col :sm="8" :xs="24">
            <el-form-item label="Cognome">
              <el-input v-model="user_partner.surname" placeholder="Inserisci cognome" />
            </el-form-item>
          </el-col>

          <el-col :sm="8" :xs="24">
            <el-form-item label="Email">
              <el-input v-model="user_partner.mail" placeholder="Inserisci email" />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-actions">
          <el-button type="primary" @click="update">
            Salva Modifiche
          </el-button>
          <router-link :to="redirectPath" class="routerLink">
            <el-button>Annulla</el-button>
          </router-link>
        </div>
      </el-form>
    </el-card>

    <!-- Password Form -->
    <el-card class="form-card" shadow="never">
      <template #header>
        <span class="card-title">Modifica Password</span>
      </template>

      <el-form :model="upd_password" label-position="top">
        <el-row :gutter="24">
          <el-col :sm="8" :xs="24">
            <el-form-item label="Vecchia Password">
              <el-input
                v-model="upd_password.password"
                type="password"
                placeholder="Inserisci password attuale"
                show-password
              />
            </el-form-item>
          </el-col>

          <el-col :sm="8" :xs="24">
            <el-form-item label="Nuova Password">
              <el-input
                v-model="upd_password.newpassword"
                type="password"
                placeholder="Inserisci nuova password"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-actions">
          <el-button type="primary" @click="update_password">
            Conferma Password
          </el-button>
          <router-link :to="redirectPath" class="routerLink">
            <el-button>Annulla</el-button>
          </router-link>
        </div>
      </el-form>
    </el-card>

    <!-- Sedi (self-service): elenco chiaro a tabella + azioni esplicite. -->
    <el-card class="form-card" shadow="never">
      <template #header>
        <div class="sedi-header">
          <span class="card-title">Le mie Sedi</span>
          <div class="sedi-actions">
            <el-button plain @click="openLinkDialog">
              <el-icon><Link /></el-icon>
              <span>Collega Sede Esistente</span>
            </el-button>
            <el-button type="primary" @click="openCreateDialog">
              <el-icon><Plus /></el-icon>
              <span>Nuova Sede</span>
            </el-button>
          </div>
        </div>
      </template>

      <el-table
        v-if="myHeadquarters.length"
        :data="myHeadquarters"
        class="sedi-table"
      >
        <el-table-column label="Nome" min-width="160">
          <template #default="{ row }">
            {{ row.name || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="Indirizzo" min-width="260">
          <template #default="{ row }">
            {{ hqAddress(row) }}
          </template>
        </el-table-column>
        <el-table-column label="Città" min-width="120">
          <template #default="{ row }">
            {{ row.city || '—' }}
          </template>
        </el-table-column>
      </el-table>
      <div v-else class="sedi-empty-box">
        Nessuna sede associata al tuo profilo. Usa
        <strong>Collega Sede Esistente</strong> o <strong>Nuova Sede</strong>.
      </div>
    </el-card>

    <!-- Dialog: collega una sede già esistente al proprio profilo -->
    <el-dialog
      v-model="linkDialogVisible"
      title="Collega una sede esistente"
      width="460px"
    >
      <el-select
        v-model="selectedHeadquarterId"
        placeholder="Cerca e seleziona una sede"
        filterable
        clearable
        style="width: 100%"
        no-data-text="Nessuna sede disponibile"
      >
        <el-option
          v-for="hq in availableHeadquarters"
          :key="hq.id"
          :label="sedeLabel(hq)"
          :value="hq.id"
        />
      </el-select>
      <template #footer>
        <el-button @click="linkDialogVisible = false">Annulla</el-button>
        <el-button
          type="primary"
          :disabled="!selectedHeadquarterId"
          :loading="addingSede"
          @click="addSede"
        >
          Collega
        </el-button>
      </template>
    </el-dialog>

    <!-- Dialog: crea una nuova sede (digitando l'indirizzo) -->
    <el-dialog
      v-model="createDialogVisible"
      title="Crea una nuova sede"
      width="560px"
    >
      <el-form :model="newSede" label-position="top">
        <el-row :gutter="16">
          <el-col :sm="12" :xs="24">
            <el-form-item label="Nome sede">
              <el-input v-model="newSede.name" placeholder="Es. Audi Ancona" />
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Indirizzo">
              <el-input v-model="newSede.address" placeholder="Via / Piazza" />
            </el-form-item>
          </el-col>
          <el-col :sm="6" :xs="24">
            <el-form-item label="Civico">
              <el-input v-model="newSede.street_number" placeholder="N." />
            </el-form-item>
          </el-col>
          <el-col :sm="6" :xs="24">
            <el-form-item label="CAP">
              <el-input v-model="newSede.cap" placeholder="60027" />
            </el-form-item>
          </el-col>
          <el-col :sm="6" :xs="24">
            <el-form-item label="Città">
              <el-input v-model="newSede.city" placeholder="Osimo" />
            </el-form-item>
          </el-col>
          <el-col :sm="6" :xs="24">
            <el-form-item label="Provincia">
              <el-input v-model="newSede.province" placeholder="AN" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="createDialogVisible = false">Annulla</el-button>
        <el-button type="primary" :loading="creatingSede" @click="createSede">
          Crea Sede
        </el-button>
      </template>
    </el-dialog>

    <!-- Stato dell'integrazione API machine-to-machine del partner
         (sola lettura; la chiave si gestisce dal gestionale Simba) -->
    <el-card class="form-card" shadow="never">
      <template #header>
        <span class="card-title">Integrazione API partner</span>
      </template>
      <div v-if="apiAccess.loading">Verifica dello stato…</div>
      <div v-else-if="apiAccess.error">
        Stato non disponibile al momento.
      </div>
      <div v-else>
        <p>
          Stato:
          <el-tag :type="apiAccess.enabled ? 'success' : 'info'">
            {{ apiAccess.enabled ? 'ATTIVA' : 'NON ATTIVA' }}
          </el-tag>
        </p>
        <p v-if="apiAccess.enabled">
          Chiave emessa il: <strong>{{ formatApiDate(apiAccess.created_at) }}</strong>
          <br />
          Ultimo utilizzo:
          <strong>{{ apiAccess.last_used_at ? formatApiDate(apiAccess.last_used_at) : 'mai' }}</strong>
        </p>
        <p style="font-size: 0.85em; color: #737373">
          L'emissione o la revoca della chiave si richiedono a Simba.
        </p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { toRaw, reactive, computed, ref } from 'vue';
import { ElMessage } from 'element-plus';
import employeeAPI from '../services/employeeAPI.js';
import journeyAPI from '../services/journeyAPI.js';
import partnerAPI from '../services/partnerAPI.js';
import { isLoggedStore } from '../store/logged';
import { useRouter } from 'vue-router';

export default {
  name: 'ProfilePage',
  setup() {
    const store = isLoggedStore();
    const router = useRouter();
    const id = toRaw(store);
    const role = toRaw(store).role.value;

    // Tutti i ruoli del partner atterrano sulla Home (vedi `landingRouteFor`).
    const redirectPath = computed(() => '/');

    const upd_password = reactive({
      mail: '',
      password: '',
      newpassword: '',
    });

    const user_partner = reactive({
      id: '',
      name: '',
      surname: '',
      date_birth: '',
      mail: '',
    });

    const loadDetails = async () => {
      try {
        const response = await employeeAPI.getEmployee(id.id.value);
        user_partner.id = response.data[0].id;
        user_partner.name = response.data[0].name;
        user_partner.surname = response.data[0].surname;
        user_partner.mail = response.data[0].mail;
      } catch (e) {
        console.error(e);
      }
    };

    const update = async () => {
      try {
        const response = await employeeAPI.updEmployee(toRaw(user_partner));
        if (response.status === 200) {
          ElMessage({
            message: 'Utente aggiornato con successo!',
            type: 'success',
          });
          router.push(redirectPath.value);
        } else {
          ElMessage.error('Errore durante il salvataggio!');
        }
      } catch {
        ElMessage.error('Errore durante il salvataggio!');
      }
    };

    const update_password = async () => {
      upd_password.mail = user_partner.mail;
      try {
        const response = await employeeAPI.updPassword(toRaw(upd_password));
        if (response.status === 201) {
          ElMessage({
            message: 'Password aggiornata con successo!',
            type: 'success',
          });
          router.push(redirectPath.value);
        } else {
          ElMessage.error('Errore durante l\'aggiornamento della password!');
        }
      } catch {
        ElMessage.error('Errore durante l\'aggiornamento della password!');
      }
    };

    // ----- Sedi self-service ------------------------------------------------
    // Etichetta sede: nome commerciale + indirizzo, fallback al solo indirizzo.
    const sedeLabel = (hq) => {
      const addr = `${hq.address} ${hq.street_number}, ${hq.city}`;
      return hq.name ? `${hq.name} — ${addr}` : addr;
    };
    // Indirizzo formattato (senza nome) per la colonna della tabella.
    const hqAddress = (hq) =>
      `${hq.address || ''} ${hq.street_number || ''}`.trim() || '—';

    const myHeadquarters = ref([]);
    const availableHeadquarters = ref([]);
    const selectedHeadquarterId = ref(null);
    const addingSede = ref(false);

    // Dialog azioni sedi (chiarezza: azioni esplicite invece della tendina).
    const linkDialogVisible = ref(false);
    const createDialogVisible = ref(false);
    const openLinkDialog = () => {
      selectedHeadquarterId.value = null;
      linkDialogVisible.value = true;
    };
    const openCreateDialog = () => {
      createDialogVisible.value = true;
    };

    const loadSedi = async () => {
      try {
        const resp = await employeeAPI.getEmployeeWithHeadquarters(id.id.value);
        const mine = resp.data?.[0]?.headquarters || [];
        myHeadquarters.value = mine;

        // Il partner si ricava dalle sedi già associate; senza sedi si
        // mostrano tutte le sedi disponibili.
        const partnerId = mine[0]?.partner?.id || null;
        const respAll = await employeeAPI.getAvailableHeadquarters(partnerId);
        const all = Array.isArray(respAll.data) ? respAll.data : [];
        const mineIds = new Set(mine.map((h) => h.id));
        availableHeadquarters.value = all.filter((h) => !mineIds.has(h.id));
      } catch (e) {
        console.error(e);
      }
    };

    const addSede = async () => {
      if (!selectedHeadquarterId.value) return;
      addingSede.value = true;
      try {
        const resp = await employeeAPI.addHeadquarter(id.id.value, {
          id: selectedHeadquarterId.value,
        });
        if (resp.data?.exist === false) {
          ElMessage.error('Utente non trovato.');
        } else {
          ElMessage({
            message: 'Sede aggiunta con successo!',
            type: 'success',
          });
        }
        selectedHeadquarterId.value = null;
        linkDialogVisible.value = false;
        await loadSedi();
      } catch (e) {
        ElMessage.error("Errore durante l'aggiunta della sede!");
      } finally {
        addingSede.value = false;
      }
    };

    // ----- Creazione nuova sede ----------------------------------------------
    const newSede = reactive({
      name: '',
      address: '',
      street_number: '',
      cap: '',
      city: '',
      province: '',
    });
    const creatingSede = ref(false);

    const createSede = async () => {
      if (
        !newSede.address ||
        !newSede.street_number ||
        !newSede.cap ||
        !newSede.city ||
        !newSede.province
      ) {
        ElMessage.error('Compila tutti i campi della nuova sede.');
        return;
      }
      // Il partner si ricava dalle sedi già associate al profilo.
      const partnerId = myHeadquarters.value[0]?.partner?.id || null;
      if (!partnerId) {
        ElMessage.error(
          'Impossibile determinare il partner: nessuna sede associata al profilo.'
        );
        return;
      }
      creatingSede.value = true;
      try {
        // Geolocalizzo la sede UNA VOLTA alla creazione: lat/lng vengono salvate
        // sull'headquarter e riusate nei journey (niente ri-geocoding a ogni uso).
        let latitude = null;
        let longitude = null;
        try {
          const geo = await journeyAPI.geocodePoint({
            address: newSede.address,
            street_number: newSede.street_number,
            cap: newSede.cap,
            city: newSede.city,
            province: newSede.province,
          });
          latitude = geo.data?.latitude ?? null;
          longitude = geo.data?.longitude ?? null;
        } catch (geoErr) {
          console.warn('Geocoding sede non riuscito:', geoErr?.message);
        }
        const resp = await employeeAPI.createHeadquarter({
          name: newSede.name || null,
          address: newSede.address,
          street_number: newSede.street_number,
          cap: newSede.cap,
          city: newSede.city,
          province: newSede.province,
          latitude,
          longitude,
          partner: { id: partnerId },
        });
        // Auto-associa la sede appena creata anche all'employee.
        const created = resp.data;
        if (created?.id) {
          await employeeAPI.addHeadquarter(id.id.value, { id: created.id });
        }
        ElMessage({
          message: 'Sede creata e associata con successo!',
          type: 'success',
        });
        Object.assign(newSede, {
          name: '',
          address: '',
          street_number: '',
          cap: '',
          city: '',
          province: '',
        });
        createDialogVisible.value = false;
        await loadSedi();
      } catch (e) {
        const msg =
          e?.response?.data?.message ||
          'Errore durante la creazione della sede!';
        ElMessage.error(Array.isArray(msg) ? msg.join(' • ') : msg);
      } finally {
        creatingSede.value = false;
      }
    };

    loadDetails();
    loadSedi();

    // Stato integrazione API del proprio partner (sola lettura, best-effort)
    const apiAccess = reactive({
      loading: true,
      error: false,
      enabled: false,
      created_at: null,
      last_used_at: null,
    });
    const loadApiAccess = async () => {
      try {
        const partnerId = toRaw(store).partner.value?.id;
        const response = await partnerAPI.getApiAccessStatus(partnerId);
        Object.assign(apiAccess, response.data, { loading: false, error: false });
      } catch (e) {
        apiAccess.loading = false;
        apiAccess.error = true;
      }
    };
    loadApiAccess();

    const formatApiDate = (d) => (d ? new Date(d).toLocaleString('it-IT') : '');

    return {
      role,
      redirectPath,
      apiAccess,
      formatApiDate,
      upd_password,
      update_password,
      update,
      user_partner,
      sedeLabel,
      hqAddress,
      myHeadquarters,
      availableHeadquarters,
      selectedHeadquarterId,
      addingSede,
      addSede,
      newSede,
      creatingSede,
      createSede,
      linkDialogVisible,
      createDialogVisible,
      openLinkDialog,
      openCreateDialog,
    };
  },
};
</script>

<style scoped>
.profile-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #171717;
  margin-bottom: 24px;
  text-align: center;
}

.form-card {
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #E5E5E5;
}

.form-card :deep(.el-card__header) {
  background-color: #FAFAFA;
  border-bottom: 1px solid #E5E5E5;
  padding: 16px 20px;
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #171717;
}

.form-card :deep(.el-card__body) {
  padding: 24px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E5E5E5;
}

.routerLink {
  text-decoration: none;
}

/* ----- Sedi ----- */
.sedi-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.sedi-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.sedi-actions .el-icon {
  margin-right: 6px;
}
.sedi-table {
  width: 100%;
}
.sedi-empty-box {
  padding: 20px;
  text-align: center;
  color: #737373;
  font-size: 0.9rem;
  background: #fafafa;
  border: 1px dashed #e5e5e5;
  border-radius: 10px;
}

/* Responsive */
@media (max-width: 768px) {
  .profile-page {
    padding: 16px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions .el-button {
    width: 100%;
  }
}
</style>
